import {Injectable} from '@angular/core';
import {AlertController} from "ionic-angular";

/*
  Generated class for the ApiErrorHandlerProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ApiErrorHandlerProvider {

    constructor(
        private alertCtrl: AlertController
    ) {
    }

    handleError(error:any , alertOptions:any = {}){

        let defaultOptions = {
            title: error.error.title ? error.error.title : '',
            message: error.error.message ? error.error.message : 'Oops, something went wrong with your request. Please try again.',
            buttons: [
                {
                    text: 'Ok'
                }
            ]
        };

        let options = Object.assign(defaultOptions, alertOptions);

        switch (true) {
            case(error.status === 422 || error.status === 401):
                return error.error.errors;
            default:

                let alert = this.alertCtrl.create(options);
                alert.present();

                return {api: 'API error'};

        }

    }
}



// WEBPACK FOOTER //
// ./src/providers/api-error-handler/api-error-handler.ts